"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteLocationService = exports.site_location_data_reducer = exports.SiteLocationAction = void 0;
var React = require("react");
var immer_1 = require("immer");
var RestData_1 = require("../rest/RestData");
var urls_1 = require("../urls");
var utils_1 = require("../utils");
var initial_data = [];
var SiteLocationAction;
(function (SiteLocationAction) {
    SiteLocationAction["CHANGE_DATA"] = "CHANGE_DATA";
})(SiteLocationAction = exports.SiteLocationAction || (exports.SiteLocationAction = {}));
function site_location_data_reducer(state, action) {
    if (action.type == RestData_1.DataActionType.LIST_POST) {
        return action.payload;
    }
    if (action.type == RestData_1.DataActionType.DELETE_POST) {
        return (0, immer_1.default)(state, function (draft) {
            var index = (0, utils_1.findIndexById)(draft, action.object_id);
            draft.splice(index, 1);
        });
    }
    if (action.type == RestData_1.DataActionType.BULK_UPDATE_POST) {
        return action.payload;
    }
    if (action.type == RestData_1.DataActionType.UPDATE_POST) {
        return (0, immer_1.default)(state, function (draft) {
            var index = (0, utils_1.findIndexById)(draft, action.object_id);
            draft[index] = action.payload;
        });
    }
    if (action.type == RestData_1.DataActionType.CREATE_POST) {
        return (0, immer_1.default)(state, function (draft) {
            draft.push(action.payload);
        });
    }
    if (action.type == SiteLocationAction.CHANGE_DATA) {
        return (0, immer_1.default)(state, function (draft) {
            var index = (0, utils_1.findIndexById)(draft, action.object_id);
            if (index != -1) {
                Object.keys(action.updates).forEach(function (name) {
                    draft[index][name] = action.updates[name];
                });
            }
        });
    }
    return state;
}
exports.site_location_data_reducer = site_location_data_reducer;
function useSiteLocationService(project_id, site_map_id) {
    var _a = __read(React.useReducer(site_location_data_reducer, initial_data), 2), site_location_data = _a[0], dispatch = _a[1];
    var rest_svc = (0, RestData_1.useRestData)((0, urls_1.resolve)(urls_1.Urls.admin_site_locations, project_id, site_map_id), dispatch);
    function change_location_data(location_id, name, value) {
        var _a;
        dispatch({
            type: SiteLocationAction.CHANGE_DATA,
            payload: undefined,
            object_id: location_id,
            updates: (_a = {},
                _a[name] = value,
                _a),
        });
    }
    function update_location_data(location_id, updates) {
        dispatch({
            type: SiteLocationAction.CHANGE_DATA,
            payload: undefined,
            object_id: location_id,
            updates: updates,
        });
    }
    return [
        site_location_data,
        __assign(__assign({}, rest_svc), { change_data: change_location_data, update_data: update_location_data }),
    ];
}
exports.useSiteLocationService = useSiteLocationService;
